import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '@gemini/ui';
import { useEffect, useState } from 'react';
const ScrollToTheTop = (props) => {
    const [isVisible, setIsVisible] = useState(false);
    const toggleVisibility = () => {
        if (window.pageYOffset > 400) {
            setIsVisible(true);
        }
        else {
            setIsVisible(false);
        }
    };
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };
    useEffect(() => {
        window.addEventListener('scroll', toggleVisibility);
        return () => {
            window.removeEventListener('scroll', toggleVisibility);
        };
    }, []);
    const breakPoint = {
        'breakpoint.base': 'spacing.16',
        'breakpoint.md': 'spacing.32',
    };
    const iconOnlyBreakPoint = {
        'breakpoint.base': true,
        'breakpoint.md': false,
    };
    return (isVisible && (_jsx(Button, { position: "fixed", bottom: breakPoint, right: breakPoint, icon: () => props.icon, iconPosition: 'end', onPress: scrollToTop, iconOnly: iconOnlyBreakPoint, children: props.text })));
};
export default ScrollToTheTop;
